module.exports = function() {
  return new Worker(__webpack_public_path__ + "8c31ce693c7ab30caeca.worker.js");
};